import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import clauseService from "./clauseService";
import { flashMessage as flash } from "./../../../utils/flash/index";

const initialState = {
  all_clauses: [],
  all_savings_clauses: [],
  isLoading: false,
  isSuccess: false,
  createSuccess: false,
  isError: false,
  isActivated: false,
  isUpdated: false,
  isUpdating: false,
  message: "",
  clause_info: {},
};

export const clauseSlice = createSlice({
  name: "clause",
  initialState,
  reducers: {
    resetClausesStatus: (state) => {
      state.isError = false;
      state.isSuccess = false;
      state.createSuccess = false;
      state.isLoading = false;
      state.isUpdated = false;
      state.message = "";
    },
    resetUpdatedStatus: (state) => {
      state.isUpdated = false;
    },
    resetClauses: (state) => initialState,
    resetSingleClause: (state) => { state.clause_info = {} }
  },
  extraReducers: (builder) => {
    builder
      // Create Clause
      .addCase(createClause.pending, (state) => {
        state.isLoading = true;
        flash("info", "Clause is being created");
      })
      .addCase(createClause.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.message) {
          state.isError = false;
          state.createSuccess = true;
          flash("success", "Clause created successfully");
        } else if (action.payload.errors) {
          state.isError = true;
          state.message = action.payload.error;
          flash("error", action.payload.errors.clause_name[0]);
        }
      })
      .addCase(createClause.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      // get all clauses
      .addCase(getAllClauses.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllClauses.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.policy_clause) {
          state.isError = false;
          state.isSuccess = true;
          state.all_clauses = action.payload.policy_clause;
          state.all_savings_clauses = action.payload.saving_policy_clause;
        } else if (action.payload.errors) {
          state.isError = true;
          state.message = action.payload.error;
          flash("error", action.payload.errors.clause_name[0]);
        }
      })
      .addCase(getAllClauses.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      // get single clause
      .addCase(getSingleClause.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getSingleClause.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.policy_clause) {
          state.isError = false;
          state.isSuccess = true;
          state.clause_info = action.payload.policy_clause;
        } else if (action.payload.errors) {
          state.isError = true;
          state.message = action.payload.error;
          flash("error", action.payload.errors.clause_name[0]);
        }
      })
      .addCase(getSingleClause.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      // Update Clause
      .addCase(updateClause.pending, (state) => {
        state.isUpdating = true;
        flash("info", "Clause is being updated");
      })
      .addCase(updateClause.fulfilled, (state, action) => {
        state.isUpdating = false;
        if (action.payload.message) {
          state.isError = false;
          state.isUpdated = true;
          flash("success", "Clause updated successfully");
        } else if (action.payload.errors) {
          state.isError = true;
          state.message = action.payload.error;
          flash("error", action.payload.errors.clause_name[0]);
        }
      })
      .addCase(updateClause.rejected, (state, action) => {
        state.isLoading = false;
        state.isUpdating = false;
        state.isError = true;
        state.message = action.payload;
      });
  },
});

// Create clause
export const createClause = createAsyncThunk(
  "/clause/create",
  async (clauseData, thunkAPI) => {
    try {
      return await clauseService.createClause(clauseData);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Get all clauses
export const getAllClauses = createAsyncThunk(
  "/clause/getAll",
  async (data, thunkAPI) => {
    try {
      return await clauseService.getAllClauses(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Get single clause
export const getSingleClause = createAsyncThunk(
  "/clause/getOne",
  async (data, thunkAPI) => {
    try {
      return await clauseService.getSingleClause(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// update clause
export const updateClause = createAsyncThunk(
  "/clause/update",
  async (clauseData, thunkAPI) => {
    try {
      return await clauseService.updateClause(clauseData);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const { resetClausesStatus, resetClauses, resetUpdatedStatus, resetSingleClause } =
  clauseSlice.actions;
export default clauseSlice.reducer;
